import ShiplineDetail from './ShiplineDetail';

export default ShiplineDetail;
